/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './Login.scss';
import loadable from '@loadable/component';
import Preloader from './Preloader/Preloader';
import footerIngenium from '../../assets/images/ingiLOGO.png';
import {
  post,
  isIosApp,
  isWebView,
  // get,
  // apiValidation,
  // setGlobalColors,
  // changeFaviconAndDocumentTitle,
} from '../../Utilities';
import {
  getCurrentBranding,
  getBrandingError,
  getBrandingPending,
  getCurrentComponent,
} from '../../redux/reducers/branding.reducer';
import { getContact } from './Login.service';
import DummyDashboard from './DummyDashboard';
import { getCreditsAvailable } from '../../redux/reducers/dashboard.reducer';
import EnterPhone2 from './FinishSetup';
// import SignupForm from './SignupForm';
// import DummyDashboard from './DummyDashboard';
// import EnterPhone from './EnterPhone';

const WelcomeCarousel = loadable(() => import('./Welcome/WelcomeCarousel'));
const SignupForm = loadable(() => import('./SignupForm'));
// const DummyDashboard = loadable(() => import('./DummyDashboard'));
const EnterPhone = loadable(() => import('./EnterPhone'));

class Login extends Component {
  constructor(props) {
    const { currentComponent } = props;
    super(props);
    this.state = {
      currentComponent: currentComponent || 'PhoneNo',
      image: null,
      showPoweredBy: 'false',
    };
  }

  componentDidMount() {
    const { currentComponent, currentbranding, history } = this.props;
    if (!Object.keys(currentbranding.branding).length) {
      history.replace('/');
    }

    this.setState({ showPoweredBy: currentbranding.branding.show_poweredby });
    console.log(currentComponent);
  }

  handleComponent = (param) => {
    this.setState({ currentComponent: param });
  };

  getPhoneNo = (param, countryCode = null) => {
    const { history } = this.props;
    const {
      currentbranding: {
        branding: { client_id: clientId },
      },
      fetchContact,
    } = this.props;
    const requestBody = {
      contact: param,
      client_id: clientId,
      country_code: countryCode,
      device: isWebView ? 'android' : isIosApp ? 'ios' : 'web',
    };

    fetchContact(param, countryCode);

    post(requestBody, '/enterNumberAndLoginLatest')
      .then((res) => {
        const result = res.result || {};
        // Browser restriction ON for this client: backend leaves the flag set
        // only when web sign-in is impossible (student-only number or a new
        // user). Show the "download the mobile app" screen in that case.
        if (result.browser_restricted && !isWebView && !isIosApp) {
          history.push('/browser-restricted');
          return;
        }
        if (result.is_user === true) {
          if (result.user_info.length === 0) {
            history.push('userservice-unavailable');
          } else {
            this.goToLoginOrSignUp(
              'signin',
              requestBody.contact,
              res.result.user_info,
              requestBody.country_code,
            );
          }
        } else {
          this.goToLoginOrSignUp('signup', requestBody.contact, null, requestBody.country_code);
        }
      })
      .catch((e) => console.error(e));
  };

  goToLoginOrSignUp(path, contact, payload = null, countryCode) {
    const {
      history: { push },
      creditsAvailable,
    } = this.props;
    const { image } = this.state;

    if (path === 'signup') {
      if (creditsAvailable < 1) {
        push('/userservice-unavailable');
      } else {
        this.setState({ currentComponent: 'SignupForm' });
      }
    } else {
      push({
        pathname: '/signin',
        state: { userInfo: payload, image, contact, countryCode },
      });
    }
  }

  render() {
    const { currentComponent, image, showPoweredBy } = this.state;
    const {
      history,
      currentbranding: {
        branding: { client_id: clientId },
      },
    } = this.props;

    return (
      <div style={{}}>
        {currentComponent === 'Preloader' && (
          <div className='text-center Login'>
            <img src={image} alt='coachingLogo' className='Login__jumbo' />

            {currentComponent === 'Preloader' && <Preloader />}

            {showPoweredBy === 'true' && (
              <footer className='py-4 Login__footer '>
                <h6 className='Login__footerText'>Powered By</h6>
                <img src={footerIngenium} alt='footerLogo' className='w-25' />
              </footer>
            )}
          </div>
        )}

        {currentComponent === 'PhoneNo' && (
          // <PhoneNo getData={this.getPhoneNo} placeholder='Mobile number' />
          <EnterPhone
            getData={this.getPhoneNo}
            placeholder='Mobile number'
            history={history}
            showPoweredBy={showPoweredBy}
          />
        )}

        {currentComponent === 'Welcome' && (
          // <Welcome data={welcomeData} changeComponent={this.handleComponent} />
          <WelcomeCarousel history={history} changeComponent={this.handleComponent} />
        )}

        {currentComponent === 'SignupForm' && (
          // <Welcome data={welcomeData} changeComponent={this.handleComponent} />
          <SignupForm history={history} changeComponent={this.handleComponent} />
        )}

        {currentComponent === 'Dummy' && (
          // <Welcome data={welcomeData} changeComponent={this.handleComponent} />
          <DummyDashboard
            clientId={clientId}
            history={history}
            changeComponent={this.handleComponent}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  error: getBrandingError(state),
  currentbranding: getCurrentBranding(state),
  pending: getBrandingPending(state),
  currentComponent: getCurrentComponent(state),
  creditsAvailable: getCreditsAvailable(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchContact: getContact,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
  }).isRequired,

  currentbranding: PropTypes.shape({
    branding: PropTypes.shape({
      client_id: PropTypes.number,
      client_logo: PropTypes.string,
      client_color: PropTypes.string,
      client_icon: PropTypes.string,
      client_title: PropTypes.string,
      show_poweredby: PropTypes.string,
    }),
    pending: PropTypes.bool.isRequired,
  }).isRequired,

  // fetchBranding: PropTypes.func.isRequired,
  // fetchColors: PropTypes.func.isRequired,
  fetchContact: PropTypes.func.isRequired,

  currentComponent: PropTypes.string.isRequired,
};
